'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _web3Utils = require('web3-utils');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EthereumAddress = require('../EthereumAddress');

var _EthereumAddress2 = _interopRequireDefault(_EthereumAddress);

var _safeToBn = require('../../utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalPaymentMethod = function ExternalPaymentMethod(props) {
  var close = props.close,
      _props$transaction = props.transaction,
      data = _props$transaction.data,
      _props$transaction$se = _props$transaction.sendOptions,
      gasPrice = _props$transaction$se.gasPrice,
      gasLimit = _props$transaction$se.gas,
      _props$transaction$se2 = _props$transaction$se.value,
      value = _props$transaction$se2 === undefined ? 0 : _props$transaction$se2,
      contract = _props$transaction.contract,
      formattedTokenAmount = _props$transaction.formattedTokenAmount;


  var tokenAmount = formattedTokenAmount || null;
  var gasFee = (0, _safeToBn2.default)(gasLimit).mul((0, _safeToBn2.default)(gasPrice));

  return _react2.default.createElement(
    'div',
    { className: 'transaction-confirmation' },
    _react2.default.createElement(
      'h2',
      null,
      'External Transaction'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Use the following values to manually create a transaction to interact directly with the smart contract.'
    ),
    _react2.default.createElement(
      'div',
      { className: 'transaction' },
      _react2.default.createElement(
        'table',
        null,
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            { className: 'address-row' },
            _react2.default.createElement(
              'td',
              { className: 'label' },
              'To Address:'
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'div',
                { className: 'address' },
                _react2.default.createElement(_EthereumAddress2.default, { address: contract })
              )
            )
          ),
          tokenAmount && _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'label' },
              'Token Amount:'
            ),
            _react2.default.createElement(
              'td',
              { className: 'address amount' },
              tokenAmount
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'label' },
              'Amount:'
            ),
            _react2.default.createElement(
              'td',
              { className: 'address' },
              (0, _web3Utils.fromWei)(value.toString()),
              ' ETH'
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'label' },
              'Gas Fee:'
            ),
            _react2.default.createElement(
              'td',
              { className: 'address' },
              (0, _web3Utils.fromWei)(gasFee),
              ' ETH'
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'label' },
              'Data:'
            ),
            _react2.default.createElement(
              'td',
              { className: 'address' },
              _react2.default.createElement(
                'div',
                { className: 'transaction-data' },
                data
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(
        'button',
        { type: 'submit', name: 'ok', className: 'btn', onClick: function onClick() {
            return close(false);
          } },
        'OK'
      )
    )
  );
};

ExternalPaymentMethod.displayName = 'ExternalPaymentMethod';

ExternalPaymentMethod.propTypes = {
  transaction: _propTypes2.default.shape({
    transaction: _propTypes2.default.shape({}),
    contract: _propTypes2.default.string.isRequired,
    sendOptions: _propTypes2.default.shape({}).isRequired
  }).isRequired,
  close: _propTypes2.default.func.isRequired
};

exports.default = ExternalPaymentMethod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/ExternalPaymentMethod.js
// module id = 1276
// module chunks = 0